import { Stack, Text } from '@zorro/web/design-system';
import { ReactElement } from 'react';

type CellValueProps = {
  value?: string | ReactElement | null;
};

function CellValue({ value }: CellValueProps) {
  if (typeof value === 'string') {
    return <Text size="sm">{value || '-'}</Text>;
  }
  return value;
}

type Props = {
  isPayrollColumn?: boolean;
  shouldShowPayrollForOneTimeCorrection: boolean;
  isEnrollmentColumn?: boolean;
  shouldShowEnrollmentForOneTimeCorrection?: boolean;
  cellValue?: string | ReactElement | null;
  secondaryCellValue?: string | ReactElement | null;
};

export function PayrollCell({
  isPayrollColumn = false,
  shouldShowPayrollForOneTimeCorrection,
  isEnrollmentColumn = false,
  shouldShowEnrollmentForOneTimeCorrection = false,
  cellValue,
  secondaryCellValue,
}: Props) {
  const shouldShowSecondaryValue =
    (isPayrollColumn && shouldShowPayrollForOneTimeCorrection) ||
    (isEnrollmentColumn && shouldShowEnrollmentForOneTimeCorrection);
  const shouldShowEmptyPlaceholder =
    shouldShowPayrollForOneTimeCorrection &&
    ((!isPayrollColumn && !isEnrollmentColumn) ||
      (isEnrollmentColumn && !shouldShowEnrollmentForOneTimeCorrection));
  return (
    <Stack gap="md" style={{ whiteSpace: 'nowrap' }}>
      <CellValue value={cellValue} />
      {shouldShowSecondaryValue && <CellValue value={secondaryCellValue} />}
      {shouldShowEmptyPlaceholder && (
        <Text size="sm" h="1.25rem">
          {' '}
        </Text>
      )}
    </Stack>
  );
}
